var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v("\n  CAP "+_vm._s(_vm.formatLabel)+" XML for this "+_vm._s(_vm.owner)+" is\n  "),_c('a',{attrs:{"href":_vm.apiUrlWithParams}},[_vm._v("provided by the API")]),_vm._v(" located at:\n  "),_c('pre',{staticClass:"url"},[_vm._v(_vm._s(_vm.apiUrlWithParams))])])
}
var staticRenderFns = []

export { render, staticRenderFns }